/** FAQ: copy deck §7. Accessible accordion via native <details>/<summary>
 * (keyboard-operable, no JS, no dependencies), styled with hairline rules and a
 * brand toggle marker. Two-column: heading left, questions right. */
import { Section, SectionHeading } from './Section.js';

const QUESTIONS = [
  {
    q: "Will RevBase hurt my domain's deliverability?",
    a: 'The opposite is the entire design goal. New mailboxes ramp gradually, sends are capped per inbox, warmup runs before cold outreach, and campaigns auto-pause if bounces or complaints spike. RevBase is built to make burning your domain hard, not easy.',
  },
  {
    q: "Does sending cold email through Gmail break Google's terms or risk my account?",
    a: 'RevBase sends through your own Google Workspace mailbox using official OAuth, with no password sharing and no sketchy SMTP relays. You stay within normal sending behavior because RevBase enforces human-paced throttling and per-inbox caps instead of dumping thousands of messages at once. Sending compliant, opt-out-respecting business email at a sane pace is exactly what the platform is designed around. (You’re responsible for following your own Workspace policy and applicable law. RevBase gives you the guardrails to stay inside it.)',
  },
  {
    q: 'How long does setup take?',
    a: 'A few minutes. Connect your Google inbox over OAuth, run the built-in SPF/DKIM/DMARC check, and start warmup. Most senders are configured the same day. We recommend a short warmup period before your first cold campaign, and RevBase walks you through it.',
  },
  {
    q: 'What about CAN-SPAM and GDPR?',
    a: 'Every message ships with a working one-click unsubscribe and the required footer, and your global suppression list is honored on every campaign automatically. Compliance isn’t a paid tier or a checkbox you have to remember. It’s on by default.',
  },
  {
    q: 'Does the AI sound like a robot?',
    a: 'Only if you let it. RevBase’s AI gives you a strong first draft and per-lead context; you edit and approve before anything sends. We deliberately don’t ship a “click here and the AI sends 5,000 generic emails” button. That’s how inboxes got flooded with obvious AI spam in the first place.',
  },
  {
    q: 'Can I send from more than one mailbox?',
    a: 'Yes. Connect multiple Google Workspace mailboxes and RevBase rotates sends across them with independent caps and ramp on each, which spreads load safely and protects any single inbox’s reputation. Plans differ on how many mailboxes you can connect.',
  },
];

export function Faq() {
  return (
    <Section id="faq">
      <div className="grid gap-10 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-4">
          <SectionHeading eyebrow="FAQ" title="Questions a careful sender asks." />
        </div>
        <div className="lg:col-span-8">
          <div className="border-t border-slate-200">
            {QUESTIONS.map((item) => (
              <details key={item.q} className="group border-b border-slate-200">
                <summary className="flex cursor-pointer list-none items-center justify-between gap-4 py-5 font-display text-lg font-semibold text-slate-900 marker:content-none">
                  {item.q}
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-white text-base text-brand-700 transition-transform duration-200 group-open:rotate-45">
                    +
                  </span>
                </summary>
                <p className="pb-6 leading-relaxed text-slate-600">{item.a}</p>
              </details>
            ))}
          </div>
        </div>
      </div>
    </Section>
  );
}
